import { render, staticRenderFns } from "./editMains.vue?vue&type=template&id=510b7d70&scoped=true&"
import script from "./editMains.vue?vue&type=script&lang=js&"
export * from "./editMains.vue?vue&type=script&lang=js&"
import style0 from "./editMains.vue?vue&type=style&index=0&id=510b7d70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b7d70",
  null
  
)

export default component.exports